var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'https://steemit.com/@' + _vm.value,"target":"_blank"}},[_c('Avatar',{attrs:{"username":_vm.value,"size":22}}),_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_c('span',{staticClass:"iconfont icon-link-external"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }